export const formatDate = isoDate => isoDate.split("-").reverse().join("/");

export const setDate = (year, month, day) => {
  const date = new Date(year, month, day)
  return date.toISOString().split("T")[0];
}

export const firstDay = date => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export const lastDay = date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

export const diffHours = (greater, less) => {
  const [gH, gM] = greater.split(":");
  const [lH, lM] = less.split(":");
  const g = (parseInt(gH) * 60) + parseInt(gM);
  const l = (parseInt(lH) * 60) + parseInt(lM);
  return g - l;
}

export const toIsoDateString = date => date.toISOString().split("T").shift();
